export default {
      id: "qr-huawei-usage",
      viewBox: "0 0 49 49",
      url: "/" + "images/icons.3.109.2.svg#qr-huawei-usage",
      toString: function () {
        return this.url;
      }
    }